// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"eeca4dd7","198":"7e50de32","404":"6e1ff0a2","498":"26f129e1"}[chunkId] + ".chunk.js";
};